import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type FrontEndDamage =
  | 'Bumper'
  | 'Grille'
  | 'Hood'
  | 'Windshield'
  | 'Fender'
  | 'Headlamp'
  | 'Corner Lamp';

export type RearEndDamage =
  | 'Bumper'
  | 'Rear Body Panel'
  | 'Trunk Lid/Tailgate'
  | 'Windshield'
  | 'Fender (Quarter Panel)'
  | 'Tail Lamp'
  | 'Side Marker Lamp';

export type SideDamage = 'Door(s)' | 'Side Mirror' | 'Door Glass';

interface DamagedPartsState {
  frontDamagedParts: Record<FrontEndDamage, boolean>;
  rearDamagedParts: Record<RearEndDamage, boolean>;
  sideDamagedParts: Record<SideDamage, boolean>;
}

const initialState: DamagedPartsState = {
  frontDamagedParts: {
    Bumper: false,
    Grille: false,
    Hood: false,
    Windshield: false,
    Fender: false,
    Headlamp: false,
    'Corner Lamp': false,
  },
  rearDamagedParts: {
    Bumper: false,
    'Rear Body Panel': false,
    'Trunk Lid/Tailgate': false,
    Windshield: false,
    'Fender (Quarter Panel)': false,
    'Tail Lamp': false,
    'Side Marker Lamp': false,
  },
  sideDamagedParts: {
    'Door(s)': false,
    'Side Mirror': false,
    'Door Glass': false,
  },
};

const damagedPartsSlice = createSlice({
  name: 'damagedParts',
  initialState,
  reducers: {
    setFrontDamagedParts: (
      state,
      { payload }: PayloadAction<{ type: FrontEndDamage; damaged: boolean }>
    ) => {
      state.frontDamagedParts[payload.type] = payload.damaged;
    },
    setRearDamagedParts: (
      state,
      { payload }: PayloadAction<{ type: RearEndDamage; damaged: boolean }>
    ) => {
      state.rearDamagedParts[payload.type] = payload.damaged;
    },
    setSideDamagedParts: (
      state,
      { payload }: PayloadAction<{ type: SideDamage; damaged: boolean }>
    ) => {
      state.sideDamagedParts[payload.type] = payload.damaged;
    },
  },
});

export const { setFrontDamagedParts, setRearDamagedParts, setSideDamagedParts } =
  damagedPartsSlice.actions;

export default damagedPartsSlice.reducer;

export function allFrontEndDamage(): FrontEndDamage[] {
  return ['Bumper', 'Grille', 'Hood', 'Windshield', 'Fender', 'Headlamp', 'Corner Lamp'];
}

export function allRearEndDamage(): RearEndDamage[] {
  return [
    'Bumper',
    'Rear Body Panel',
    'Trunk Lid/Tailgate',
    'Windshield',
    'Fender (Quarter Panel)',
    'Tail Lamp',
    'Side Marker Lamp',
  ];
}

export function allSideDamage(): SideDamage[] {
  return ['Door(s)', 'Side Mirror', 'Door Glass'];
}
